export type IndustryId = "food-and-beverages" | "commercial-printing";

export interface Industry {
  id: IndustryId;
  locale: {
    es: string;
  };
}

export type Industries = Record<IndustryId, Industry>;

export const industries: Industries = {
  "food-and-beverages": {
    id: "food-and-beverages",
    locale: {
      es: "Alimentos y Bebidas",
    },
  },
  "commercial-printing": {
    id: "commercial-printing",
    locale: {
      es: "Impresión Comercial",
    },
  },
};
